/**
 * @file index.tsx
 *
 * @fileoverview Renders mobile header.
 */
import React, { useContext } from 'react';
import Link from '~/jobiqo/components/Link';
import { Branding } from '~/jobiqo/components/Branding';
import { HeaderContext, HeaderContextInterface } from '~/jobiqo/context/header';
import { MenuLeftIcon } from '~/vcl/icons/MenuLeft';
import { SearchIcon } from '~/vcl/icons/Search';
import { getFrontendTheme } from '~/jobiqo/utils/getFrontend';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface MobileHeaderProps {
  searchLink?: string;
  NavTag: any;
  toggleNav: () => void;
}
export default function MobileHeader({
  searchLink,
  NavTag,
  toggleNav,
}: MobileHeaderProps) {
  const headerContext: HeaderContextInterface = useContext(HeaderContext);
  const frontendConfig = useFrontendConfig();
  const frontendTheme = getFrontendTheme(frontendConfig);

  const redirectToSearch = searchLink && !headerContext.handleSearchClick;
  return (
    <NavTag>
      {headerContext.leftButton ?? (
        <button onClick={() => toggleNav()}>
          <MenuLeftIcon
            color={frontendTheme.NAVIGATION.MOBILE.BUTTONS_STYLE}
            height="30"
            width="30"
            title="Menu"
          />
        </button>
      )}
      <div>
        <Branding
          {...(frontendTheme.NAVIGATION.LOGO
            ? { customLogo: frontendTheme.NAVIGATION.LOGO }
            : null)}
        />
      </div>
      {headerContext.rightButton ??
        (redirectToSearch ? (
          <Link href={searchLink}>
            <SearchIcon
              color={frontendTheme.NAVIGATION.MOBILE.BUTTONS_STYLE}
              height="30"
              width="30"
              title="Search"
            />
          </Link>
        ) : (
          <button onClick={headerContext.handleSearchClick}>
            <SearchIcon
              color={frontendTheme.NAVIGATION.MOBILE.BUTTONS_STYLE}
              height="30"
              width="30"
              title="Search"
            />
          </button>
        ))}
    </NavTag>
  );
}
